module.exports = __webpack_public_path__ + "img/model_44_zh.c94a818a.jpg";